import { Box, useTheme } from "@mui/material";

export default function FrostedCard({ tone = "neutral", blur = 16, sx, children, ...rest }) {
    const theme = useTheme();
    const w = theme.custom?.wizard ?? {};
    const border = w.stateTints?.[tone]?.discBorder ?? "rgba(244,242,238,0.08)";

    return (
        <Box
            {...rest}
            sx={{
                background: "rgba(36,56,66,0.92)",
                border: `1px solid ${border}`,
                borderRadius: `${w.microRadius ?? 14}px`,
                "@supports (backdrop-filter: blur(20px)) or (-webkit-backdrop-filter: blur(20px))": {
                    background: w.microBg ?? "rgba(36,56,66,0.65)",
                    backdropFilter: `blur(${blur}px) saturate(140%)`,
                    WebkitBackdropFilter: `blur(${blur}px) saturate(140%)`,
                },
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
